module.exports = __webpack_public_path__ + "img/stickers-bilan.e13c6e3a.jpg";